import type { AnrokBackfillTransactionsRequestPayload } from '@vy/api-definition';
import { useMutation, type UseMutationOptions } from 'react-query';
import { getPrivateApi } from '../../../../services/api';

export function useAnrokBackfillTransactions(
  options?: UseMutationOptions<void, unknown, AnrokBackfillTransactionsRequestPayload>,
) {
  return useMutation(async (anrokBackfillTransactionsRequest: AnrokBackfillTransactionsRequestPayload) => {
    const api = getPrivateApi();

    return api.anrokBackfillTransactions({ anrokBackfillTransactionsRequest });
  }, options);
}
